/** Action names recorded in event_analytics. Shared by client and server. */
export const ANALYTICS_ACTIONS = [
  "page_view",
  "events_index_view",
  "share_opened",
  "share_native",
  "share_channel",
  "signup_form_opened",
  "signup_form_started",
  "signup_submitted",
  "claim_completed",
  "claim_failed",
  "claim_abandoned",
  "email_confirmation_sent",
  "email_alert_sent",
  "email_link_click",
  "manage_page_view",
  "spot_released",
  "qr_scan",
  "qr_link_copied",
  "qr_downloaded",
  "interest_joined",
  "volunteer_selfsignup",
] as const;

export type AnalyticsAction = (typeof ANALYTICS_ACTIONS)[number];

/** Canonical traffic sources. `src` query values map onto these. */
export const SOURCE_ALIASES: Record<string, string> = {
  qr: "qr",
  qrcode: "qr",
  email: "email",
  confirmation: "email",
  manage: "email",
  sms: "sms",
  text: "sms",
  fb: "facebook",
  facebook: "facebook",
  x: "x",
  twitter: "x",
  li: "linkedin",
  linkedin: "linkedin",
  wa: "whatsapp",
  whatsapp: "whatsapp",
  ig: "instagram",
  instagram: "instagram",
  tiktok: "tiktok",
  copy: "copy_link",
  admin: "admin_link",
  direct: "direct",
};

export const SOURCE_LABELS: Record<string, string> = {
  qr: "QR code",
  email: "Email",
  sms: "Text message",
  facebook: "Facebook",
  x: "X",
  linkedin: "LinkedIn",
  whatsapp: "WhatsApp",
  instagram: "Instagram",
  tiktok: "TikTok",
  copy_link: "Copied link",
  admin_link: "Admin shared link",
  direct: "Direct",
  search: "Search",
  referral: "Referral",
  social: "Social referral",
};

export function normalizeSource(value?: string | null) {
  const key = (value ?? "").trim().toLowerCase().slice(0, 40);
  if (!key) return null;
  return SOURCE_ALIASES[key] ?? (key.replace(/[^a-z0-9_-]/g, "").slice(0, 40) || null);
}

export function sourceLabel(source: string) {
  return SOURCE_LABELS[source] ?? source;
}

/** Appends the tracking source to a public event URL. */
export function taggedUrl(url: string, source: string) {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set("src", source);
    return parsed.toString();
  } catch {
    return url.includes("?") ? `${url}&src=${source}` : `${url}?src=${source}`;
  }
}
